//
//
//
//

import MediaView from "../components-v2/MediaView.vue";
export default {
  components: {
    MediaView,
  },
};
